import React, { useState, useEffect, useCallback } from 'react';
import { createUseStyles } from 'react-jss';
import {
  FaMapMarker,
  FaFacebook,
  FaTwitter,
  FaDribbble,
  FaInstagram,
  FaPinterest,
  FaGlobe,
  FaUserPlus,
  FaUserCheck,
} from 'react-icons/fa';
import Button from '../../components/Button';
import Image from 'react-bootstrap/Image';

import { Article, User } from '../../types';
import Text from '../../components/Text';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../config/store';
import { unfollowUser, followUser } from '../../services/ProfileService';
import { removeUserFollow, addUserFollow } from '../../actions/auth';
import { showLoginModal, showAddressModal } from '../../actions/ui';
import clsx from 'clsx';
import { track } from '../../services/mixpanelService';


export interface UserDetailsProps {
  user: User;
  isMyProfile: boolean;
}

const UserDetails: React.FC<UserDetailsProps> = ({ user, isMyProfile }) => {
  const classes = useStyles();
  const isAuthenticated = useSelector<RootState, boolean>(
    (state) => state.auth.isAuthenticated,
  );
  const followerList = useSelector<RootState, number[]>(
    (state) => state.auth.usersFollow,
  );
  const openNewTab = useCallback((url): void => {
    let win = window.open( url, '_blank');
    win?.focus();
  }, [])
  const [isFollower, setIsFollower] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (followerList.indexOf(+user.id) != -1) {
      setIsFollower(true);
    }
    else {
      setIsFollower(false);
    }
  }, [followerList, user])



  const handleUserFollow = useCallback(() => {
    (async () => {
      try {
        if (!isAuthenticated) {
          dispatch(showLoginModal());
          return
        }
        if (isFollower) {
          await unfollowUser(+user.id);
          dispatch(removeUserFollow(+user.id));
          user.followersCount--;
          track("un_follow")

        } else {
          await followUser(+user.id);
          dispatch(addUserFollow(+user.id));
          user.followersCount++;
          track("follow")

        }
      } catch (e) { }
    })();
  }, [isFollower, user, isAuthenticated]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.avatarBox}>
          <Image
            className={classes.avatar}
            src={user.avatarUrl}
            alt={user.name}
            roundedCircle
          />
        </div>
        <div className={classes.statusBox}>
          <Text className="mb-0" color="white" align="center" bold>
            {user.position}
          </Text>
          {/* <Text className="m-0" color="white" align="center">
            {user.score} pts
          </Text> */}
        </div>
      </div>
      
      <div className={classes.content}>
        <Text as="h1" fontSize="size2" align="center" bold>
          {user.name}
        </Text>
        <Text as="p" align="center">
          {user.about}
        </Text>
        {/* <Text align="center">
          <Text as="span" subText>
            <FaMapMarker size={20} />
          </Text>{' '}
          Dubai, UAE
        </Text> */}
        {/* <Text align="center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Est adipisci
          dignissimos a dolor itaque nesciunt aliquam.
        </Text> */}

        {!isMyProfile ?

          !isFollower ? (
            <Button
              // key={button.id}
              // className={clsx(classes.actionBtn)}
              color="primary"
              size="small"
              onClick={handleUserFollow}
              rounded
            >
              <Text as="span" color="white" bold capitalized>

                <FaUserPlus className={classes.followIcon} />
    Follow
  </Text>
            </Button>
          ) : (
            <Button
              // key={button.id}
              className={clsx(classes.followBtn)}
              color="primary"
              size="small"
              onClick={handleUserFollow}
              rounded
            >
              <Text as="span" color="white" bold capitalized>

                <FaUserCheck className={classes.followIcon} />
    Following
  </Text>
            </Button>
          )
          : null
        }
        <div className={classes.statsContainer}>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {user.followersCount}
            </Text>
            <Text className={classes.statsText}>Followers</Text>
          </div>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {user.likesCount}
            </Text>
            <Text className={classes.statsText}>Likes</Text>
          </div>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {user.followingCount}
            </Text>
            <Text className={classes.statsText}>Following</Text>
          </div>
          <div className={classes.statsCard}>
            <Text className={classes.statsNumber} bold>
              {user.twigsCount}
            </Text>
            <Text className={classes.statsText}>Twigs</Text>
          </div>
        </div>

                
        <div className={classes.socailBox}>
          {user.facebook ? <FaFacebook onClick={() => openNewTab(user.facebook)} className={classes.socialIcon} /> : null}
          {user.twitter ? <FaTwitter onClick={() => openNewTab(user.twitter)} className={classes.socialIcon} /> : null}
          {user.instagram ? <FaInstagram onClick={() => openNewTab(user.instagram)} className={classes.socialIcon} /> : null}
          {user.pinterest ? <FaPinterest onClick={() => openNewTab(user.pinterest)} className={classes.socialIcon} /> : null}
          {user.website ? <FaGlobe onClick={() => openNewTab(user.website)} className={classes.socialIcon} /> : null}
        </div>
      </div>
    </div>
  );
};

const useStyles = createUseStyles({
  wrapper: {
    position: 'relative',
  },
  header: {
    position: 'relative',
    height: '140px',
  },
  avatarBox: {
    width: '160px',
    height: '160px',
    position: 'absolute',
    left: 0,
    right: 0,
    margin: 'auto',
    top: '-80px',
    // zIndex: '1',
  },
  
  avatar: {
    width: '100%',
    height: '100%',
    objectFit:'cover',
    border: '8px solid #FFFFFF',
  },
  statusBox: {
    backgroundColor: '#522583',
    overflow: 'hidden',
    // zIndex: '2',
    maxWidth: '168px',
    position: 'absolute',
    left: '0',
    right: 0,
    margin: 'auto',
    padding: '10px',
    top: '50px',
    borderRadius: '5px',
    boxShadow: '0px 0px 0px 5px #FFFFFF',
  },
  content: {
    textAlign: 'center'
    // marginTop: '100px',
  },
  statsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  statsCard: {
    padding: '0.5rem 1rem',
    flex: 1,
    textAlign: 'center',
  },
  statsText: {
    fontSize: '1rem',
    color: '#aaaaaa',
  },
  statsNumber: {
    fontSize: '1.5rem',
  },
  socailBox: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  socialIcon: {
    margin: '5px',
    fontSize: '20px',
    color: '#555555',
    cursor: 'pointer'
  },
  followBtn: {
    backgroundColor: "black"
  },
  followIcon: {
    margin: '0px 3px',
    marginBottom: '3px',
    fontSize: '18px',
    color: 'white'
  },
  
  
});

export default UserDetails;
